import { Star } from "lucide-react";

export const StarDisplay = ({ rating, testId }: { rating: number; testId?: string }) => (
  <span data-testid={testId} className="flex gap-1" aria-label={`${rating} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        className={`h-4 w-4 ${i <= rating ? "fill-gold text-gold" : "text-neutral-700"}`}
      />
    ))}
  </span>
);

export const StarInput = ({
  value,
  onChange,
  testId,
}: {
  value: number;
  onChange: (v: number) => void;
  testId: string;
}) => (
  <div data-testid={testId} className="flex gap-2" role="radiogroup" aria-label="Star rating">
    {[1, 2, 3, 4, 5].map((i) => (
      <button
        key={i}
        type="button"
        data-testid={`${testId}-${i}`}
        onClick={() => onChange(i)}
        aria-label={`${i} star${i > 1 ? "s" : ""}`}
        className="transition-transform duration-200 hover:scale-110"
      >
        <Star
          className={`h-8 w-8 transition-colors duration-200 ${
            i <= value ? "fill-gold text-gold" : "text-neutral-600 hover:text-gold/60"
          }`}
        />
      </button>
    ))}
  </div>
);
